// Types
import type { TStripNull } from '~/shared/utils/types';

const stripNullValues = <T extends Record<string, unknown>>(obj: T): TStripNull<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== null)) as TStripNull<T>;

export { stripNullValues };
